import { deleteVoucherDevolucion, getEstadoCuentaDevolucionDowload, getVoucherDevolucion, postCargarVoucherRembolso } from "../services/documentosService";
import { getDevolucionesHistoricoAll } from "../services/refoundService";

const dataInicial = {
    listDevolucionesHistoria: [],
    pagina: 0,
    registros: 10,
    busqueda: "0",
    filtroEstatus: "3",
    total: 0,
    exito: 0,
}

const GET_DEVOLUCIONES_HISTORIAL_ALL = "GET_DEVOLUCIONES_HISTORIAL_ALL";
const GET_DEVOLUCIONES_HISTORIAL_PAGINA = "GET_DEVOLUCIONES_HISTORIAL_PAGINA";
const GET_DEVOLUCIONES_HISTORIAL_REGISTROS = "GET_DEVOLUCIONES_HISTORIAL_REGISTROS";
const GET_DEVOLUCIONES_HISTORIAL_BUSQUEDA = "GET_DEVOLUCIONES_HISTORIAL_BUSQUEDA";
const CLEAR_DEVOLUCIONES_HISTORIAL = "CLEAR_DEVOLUCIONES_HISTORIAL";
const GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD = "GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD"
const POST_DEVOLUCIONES_HISTORIAL_VOUCHER = "POST_DEVOLUCIONES_HISTORIAL_VOUCHER"
const GET_DEVOLUCIONES_HISTORIAL_VOUCHER_DOWLOAD = "GET_DEVOLUCIONES_HISTORIAL_VOUCHER_DOWLOAD"
const DELETE_DEVOLUCIONES_HISTORIAL_VOUCHER = "DELETE_DEVOLUCIONES_HISTORIAL_VOUCHER"
const GET_DEVOLUCIONES_HISTORIAL_FILTRO = "GET_DEVOLUCIONES_HISTORIAL_FILTRO"

export default function devolucioenesHistoriaReducer(state = dataInicial, action) {
    switch (action.type) {
        case GET_DEVOLUCIONES_HISTORIAL_FILTRO:
            return { ...state, listDevolucionesHistoria: action.payload.listDevolucionesHistoria, total: action.payload.total, filtroEstatus: action.payload.filtroEstatus, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
        case DELETE_DEVOLUCIONES_HISTORIAL_VOUCHER:
            return { ...state, exito: action.payload.exito }
        case GET_DEVOLUCIONES_HISTORIAL_VOUCHER_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        case POST_DEVOLUCIONES_HISTORIAL_VOUCHER:
            return { ...state, exito: action.payload.exito }
        case GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD:
            return { ...state, exito: action.payload.exito }
        case GET_DEVOLUCIONES_HISTORIAL_ALL:
            return { ...state, listDevolucionesHistoria: action.payload.listDevolucionesHistoria, total: action.payload.total }
        case GET_DEVOLUCIONES_HISTORIAL_PAGINA:
            return { ...state, listDevolucionesHistoria: action.payload.listDevolucionesHistoria, pagina: action.payload.pagina, total: action.payload.total }
        case GET_DEVOLUCIONES_HISTORIAL_REGISTROS:
            return { ...state, listDevolucionesHistoria: action.payload.listDevolucionesHistoria, registros: action.payload.registros, total: action.payload.total }
        case GET_DEVOLUCIONES_HISTORIAL_BUSQUEDA:
            return { ...state, listDevolucionesHistoria: action.payload.listDevolucionesHistoria, busqueda: action.payload.busqueda, total: action.payload.total, pagina: action.payload.pagina, registros: action.payload.registros, filtroEstatus: action.payload.filtroEstatus }
        case CLEAR_DEVOLUCIONES_HISTORIAL:
            return { ...state, listDevolucionesHistoria: action.payload.array, pagina: action.payload.pagina, registros: action.payload.registros, busqueda: action.payload.busqueda }
        default:
            return state;
    }
}
export const obtenerDevolucionesHistorialFiltroAction = ({filtroEstatus}) => async (dispatch, getSate) => {
    return await getDevolucionesHistoricoAll({ Referencia: dataInicial.busqueda, IdCatEstatusDevolucion: filtroEstatus, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_HISTORIAL_FILTRO,
            payload: {
                listDevolucionesHistoria: Response.Devoluciones,
                total: Response.Total,
                busqueda: dataInicial.busqueda,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
                filtroEstatus: filtroEstatus
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const eliminarDevolucionesVoucherAction = ({ IdDevolucionComprobante }) => async (dispatch, getSate) => {
    return await deleteVoucherDevolucion({ IdDevolucionComprobante }).then(Response => {
        dispatch({
            type: DELETE_DEVOLUCIONES_HISTORIAL_VOUCHER,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerDevolucionesVoucherDescargaAction = ({ IdDevolucionComprobante }) => async (dispatch, getSate) => {
    return await getVoucherDevolucion({ IdDevolucionComprobante }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_HISTORIAL_VOUCHER_DOWLOAD,
            payload: {
                exito: 1,
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}

export const obtenerDevolucionesHistorialAction = () => async (dispatch, getSate) => {
    const { busqueda, pagina, registros, filtroEstatus } = getSate().devolucionesHistorial
    return await getDevolucionesHistoricoAll({ Pagina: pagina + 1, IdCatEstatusDevolucion: filtroEstatus, Referencia: busqueda, Registros: registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_HISTORIAL_ALL,
            payload: {
                listDevolucionesHistoria: Response.Devoluciones,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}

export const obtenerDevolucionesHistorialPaginaAction = ({ Pagina }) => async (dispatch, getSate) => {
    const { busqueda, registros, filtroEstatus } = getSate().devolucionesHistorial
    return await getDevolucionesHistoricoAll({ Pagina: Pagina + 1, Referencia: busqueda, IdCatEstatusDevolucion: filtroEstatus, Registros: registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_HISTORIAL_PAGINA,
            payload: {
                listDevolucionesHistoria: Response.Devoluciones,
                total: Response.Total
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerDevolucionesHistorialRegistrosAction = ({ Registros }) => async (dispatch, getSate) => {
    const { busqueda, pagina, filtroEstatus } = getSate().devolucionesHistorial
    return await getDevolucionesHistoricoAll({ Referencia: busqueda, IdCatEstatusDevolucion: filtroEstatus, Pagina: pagina + 1, Registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_HISTORIAL_REGISTROS,
            payload: {
                listDevolucionesHistoria: Response.Devoluciones,
                total: Response.Total,
                registros: Registros,
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerDevolucionesHistorialBusquedaAction = ({ Referencia }) => async (dispatch, getSate) => {
    return await getDevolucionesHistoricoAll({ Referencia: Referencia, IdCatEstatusDevolucion: dataInicial.filtroEstatus, Pagina: dataInicial.pagina + 1, Registros: dataInicial.registros }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_HISTORIAL_BUSQUEDA,
            payload: {
                listDevolucionesHistoria: Response.Devoluciones,
                total: Response.Total,
                busqueda: Referencia,
                registros: dataInicial.registros,
                pagina: dataInicial.pagina,
                filtroEstatus: dataInicial.filtroEstatus
            },
        });
        return Response
    }).catch(Error => {
        return {}
    })
}
export const obtenerEstadoCuentaDevolucionAction = ({ IdDevolucionSolicitud }) => async (dispatch, getSate) => {
    return await getEstadoCuentaDevolucionDowload({ IdDevolucionSolicitud }).then(Response => {
        dispatch({
            type: GET_DEVOLUCIONES_ESTADO_CUENTA_DOWLOAD,
            payload: {
                exito: 1
            },
        });
        return Response
    }).catch(Error => {
        return Error
    })
}
export const cargarVoucherDevolucionAction = ({ Extension, IdDevolucionSolicitud, Imagen, Nombre }) => async (dispatch, getSate) => {
    return await postCargarVoucherRembolso({ Extension, IdDevolucionSolicitud, Imagen, Nombre }).then(Resposne => {
        dispatch({
            type: POST_DEVOLUCIONES_HISTORIAL_VOUCHER,
            payload: {
                exito: 1
            },
        })
    }).catch(Error => {
        return Error
    })
}
